import { useState } from 'react';
import { Alert, Button, Col, ControlLabel, Form, FormGroup, Modal } from 'react-bootstrap';
import { FileRejection, DropEvent } from 'react-dropzone';
import FileUpload from '@nkr/components/file-upload';
import styled from 'styled-components';

const CenteredModal = styled(Modal)`
    .modal-dialog {
        display: flex;
        align-items: center;
        min-height: calc(100vh - 60px);
    }
`;

interface IProps {
    show: boolean;
    fullName: string;
    onSubmit: (file: File) => void;
    onCancel: () => void;
}

const UploadAboModal = (props: IProps) => {
    const [files, setFiles] = useState<File[]>([]);

    const handleFileDropped = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        setFiles(acceptedFiles);
    };

    const handleRemoveFile = () => {
        setFiles([]);
    };

    const handleSubmit = () => {
        console.log('handleSubmit called, files:', files);
        if (files.length > 0) {
            console.log('Calling onSubmit with file:', files[0]);
            props.onSubmit(files[0]);
        }
    };

    const disableUploadButton = files.length === 0;

    return (
        <CenteredModal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Upload ABO Results</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <blockquote className='row' style={{ margin: '0px 0px 20px 0px' }}>
                    <div className='col-xs-12'>Patient: {props.fullName}</div>
                </blockquote>

                <FormGroup>
                    <FileUpload
                        label='Click here to select the ABO results PDF file...'
                        files={files}
                        accept='.pdf'
                        onFileDropped={handleFileDropped}
                        onRemoveFile={handleRemoveFile}
                        singleUploadOnly={true}
                    />
                </FormGroup>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' disabled={disableUploadButton} onClick={handleSubmit}>Upload Document</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </CenteredModal>
    );
};

export default UploadAboModal; 